<mat-form-field class="form-field">
  <input matInput type="text" [(ngModel)]="filterValue" (keyup)="onFilterChange()" [placeholder]="searchLabel" />
  <mat-icon matSuffix *ngIf="!filterActive">search</mat-icon>
  <mat-icon class="c-pointer" matSuffix (click)="resetFilter()" *ngIf="filterActive">clear</mat-icon>
</mat-form-field>
